import React from 'react';

function FormAlert({type, message}) {
  return (
    <section className={"alert alert--" + type}>
      {message}
    </section>
  )
}

export default FormAlert;
